import React from 'react';

/** "received of ordered" as a bar plus the two numbers. Green when complete, amber when partial. */
export interface ProgressCellProps {
  done: number;
  total: number;
  /** Text after the numbers, e.g. a unit. */
  suffix?: React.ReactNode;
  format?: (n: number) => string;
  compact?: boolean;
}

const fmt = (n: number) => Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 });

const ProgressCell: React.FC<ProgressCellProps> = ({ done, total, suffix, format = fmt, compact }) => {
  const pct = total > 0 ? Math.max(0, Math.min(100, (done / total) * 100)) : 0;
  const complete = total > 0 && done >= total;
  return (
    <span style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
      {!compact && (
        <span
          style={{
            display: 'inline-block',
            width: 72,
            height: 6,
            background: '#f5f6f8',
            border: '1px solid #e3e6ec',
            borderRadius: 3,
            verticalAlign: 'middle',
            marginRight: 6,
            overflow: 'hidden',
          }}
        >
          <span style={{ display: 'block', height: '100%', width: `${pct}%`, background: complete ? '#1a7f4b' : '#d48806' }} />
        </span>
      )}
      <span>{format(done)} / {format(total)}</span>
      {suffix ? <span style={{ color: '#8a94a6', marginLeft: 4 }}>{suffix}</span> : null}
    </span>
  );
};

export default ProgressCell;
